import React from 'react'

import Connection from '@components/Connection'
import Amenity from '@components/JourneyCard/Footer/Amenity'
import StationInfo from '@components/TripInfo/StationInfo'
import TransferTime from '@components/TripInfo/TransferTime'
import connectionUtils from '@lib/connection'

import '@components/CompactTripCard/TripDetails/styles.scss'

interface TripDetailsProps {
  segment: Segment
  next?: Segment
  previous?: Segment
  isLastSegment: boolean
  connection: Connection
}

const TripDetails = ({ segment, next, previous, isLastSegment }: TripDetailsProps) => {
  const isSelfTransfer = connectionUtils.isSelfTransfer(segment)
  const transferArrival = isSelfTransfer && previous ? previous : segment

  return (
    <div className="trip-details-container">
      <div className="trip-content">
        <div className="stations-info">
          <StationInfo
            type="departure"
            station={segment.departureStation}
            time={segment.departureTime}
            duration={
              <Connection.Duration
                departureTime={segment.departureTime}
                arrivalTime={segment.arrivalTime}
                departureTimezone={segment.departureStation.timeZone}
                arrivalTimezone={segment.arrivalStation.timeZone}
              />
            }
            vehicle={segment.vehicle?.vehicleType?.code}
          />
          <StationInfo
            type="arrival"
            station={segment.arrivalStation}
            time={segment.arrivalTime}
            vehicle={segment.vehicle?.vehicleType?.code}
          />
        </div>
        <div className="amenities-list">
          {segment.amenities?.map(item => <Amenity key={item.id} fareFeature={item} />)}
        </div>
      </div>
      {!isLastSegment &&
        next &&
        !connectionUtils.isSelfTransfer(next) &&
        next.departureTime !== transferArrival.arrivalTime && (
          <TransferTime
            departureTime={next.departureTime}
            departureTimezone={next.departureStation.timeZone}
            arrivalTime={transferArrival.arrivalTime}
            arrivalTimezone={transferArrival.arrivalStation.timeZone}
            selfTransfer={isSelfTransfer}
          />
        )}
    </div>
  )
}

export default TripDetails
